<template>
    <div v-if="course">
        <BCard>
            <BRow>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="UserIcon" vsLabel="Name" :vsValue="course.name" />
                        <ViewData vsIcon="UserIcon" vsLabel="Enrollment code" :vsValue="course.code" />
                        <ViewData vsIcon="HomeIcon" vsLabel="Group" :vsValue="course.group ? course.group.name : 'Todas'" />
                        <ViewData vsIcon="BriefcaseIcon" vsLabel="Section" :vsValue="course.section.name" />
                        <ViewData vsIcon="MailIcon" vsLabel="End date" :vsValue="course.end_date ? formatDate(course.end_date) : ''" />
                        <ViewData vsIcon="MailIcon" vsLabel="Enrollment end date" :vsValue="course.enrollment_end_date ? formatDate(course.enrollment_end_date) : ''" />
                    </table>
                </BCol>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="UserIcon" vsLabel="Places" :vsValue="course.places" />
                        <ViewData vsIcon="DollarSignIcon" vsLabel="Tax" :vsValue="course.tax.name" />
                        <ViewData vsIcon="ShieldIcon" vsLabel="Matrícula" :vsValue="new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(course.amount)" />
                        <ViewData vsIcon="ShieldIcon" vsLabel="Mensualidad" :vsValue="new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(course.monthly_payment)" />
                        <ViewData vsIcon="MailIcon" vsLabel="Start date" :vsValue="formatDate(course.start_date)" />
                        <ViewData vsIcon="MailIcon" vsLabel="Enrollment start date" :vsValue="formatDate(course.enrollment_start_date)" />
                    </table>
                </BCol>

                <BCol v-if="cursoMensual" cols="12" xl="6">
                    <table class="mt-2 mt-xl-2 w-100">
                        <ViewData vsIcon="DollarSignIcon" vsLabel="Pago primer mes" :vsValue="course.first_month_payment ? formatCurrency(course.first_month_payment) : '-'" />
                        <ViewData vsIcon="DollarSignIcon" vsLabel="Pago último mes" :vsValue="course.last_month_payment ? formatCurrency(course.last_month_payment) : '-'" />
                    </table>
                </BCol>
 
                <BCol v-if="!cursoMensual" cols="12" xl="6">
                    <table class="mt-2 mt-xl-2 w-100">
                        <ViewData vsIcon="DollarSignIcon" :vsLabel="'Plazo '+(index + 1)" :vsValue="formatCurrency(term.term_payment)+'  Inicio: '+formatDate(term.start_date)" v-for="(term, index) in termsCourse" :key="index"  />

                    </table>
                </BCol>

                <BCol cols="12" class="mt-2">
                    <div class="d-flex flex-wrap">
                        <BButton :to="{ name: 'courses-edit', params: { id: course.id } }" variant="primary" v-if="ability.can('write', 'course')"> {{$t('Edit')}} </BButton>
                        <BButton variant="outline-danger" class="ml-1" @click="deletePopup(course.id, 'courses/deleteCourse', 'courses')" v-if="ability.can('delete', 'course')"> {{$t('Delete')}} </BButton>
                    </div>
                </BCol>
            </BRow>
        </BCard>
        <!-- <CoursesViewStudents :key="reRenderKey" />
        <CoursesViewLessons /> -->
        <!-- <EvaluationsTable @re-render-notes="reRenderNotes"/> -->
    </div>
</template>

<script>
import { BAlert, BRow, BCard, BCol, BButton, BLink, BCardBody, BCardTitle, BCardSubTitle } from 'bootstrap-vue'
import { provide, ref, onUnmounted, inject } from '@vue/composition-api'
import ViewData from '@/components/ViewData.vue'
import ability from '@/libs/acl/ability'
import popups from '@/hooks/popups'
import dateUtils from '@/hooks/dateUtils' 
import currency from '@/utils/currency'

export default {
    components: { BAlert, BRow, BCol, BCard, BButton, BLink, ViewData, BCardBody, BCardTitle, BCardSubTitle },
    setup(){
        const { formatCurrency } = currency()
        const { formatDate } = dateUtils()
        const { deletePopup } = popups();
        const termsCourse=ref(null)
        const cursoMensual=ref(null)
        const reRenderKey = ref(0)

        const course = inject('course') 

        const reRenderNotes = () => {
            reRenderKey.value++
        }
        
        return {
            course,
            ability,
            deletePopup,
            cursoMensual, 
            termsCourse, 
            formatDate,
            formatCurrency,
            reRenderNotes,
            reRenderKey
        }
    }
}
</script>

<style lang="scss">
@import 'src/assets/scss/variables/_variables.scss';
table tr th {
  color: $primary;
}

table tr th span {
  text-transform: uppercase;
}
</style>
